module.exports = __webpack_public_path__ + "img/185.26fa860e.jpg";